import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'

type WidgetColor = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';

@customElement('vxc-widget')
export class TWidget extends LitElement {
    @property({ type: String, attribute: 'title' }) header = '';
    @property({ type: String, attribute: 'variant' }) variant: WidgetColor = 'secondary';

    static styles = css`
       :host {
            display: block;
            width: 100%;
            height: 100%;
            --vx-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
            --vx-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
            --vx-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
            --vx-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
        }

        .card {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            border-radius: 0.25rem;
            box-shadow: var(--vx-box-shadow-sm);
            background-color: white;
            overflow: hidden;
        }

        .card-header {
            padding: 0.25rem 1.25rem;
            font-weight: 500;
            color: white;
            flex-shrink: 0
        }

        .card-header.primary { background-color: #007bff; }
        .card-header.secondary { background-color: #6c757d; }
        .card-header.success { background-color: #28a745; }
        .card-header.danger { background-color: #dc3545; }
        .card-header.warning { 
            background-color: #ffc107;
            color: #212529;
        }
        .card-header.info { background-color: #17a2b8; }
        .card-header.light { 
            background-color: #f8f9fa;
            color: #212529;
        }
        .card-header.dark { background-color: #343a40; }

        .card-body {
            flex: 1 1 0%;
            min-height: 0;
            padding: 1.25rem;
            overflow-y: auto;
            background: white;
        }

        ::slotted(*) {
            margin: 0;
            width: 100%;
            height: 100%;
        }
    `;

    render() {
        console.log('widget', this.header)
        return html`
            <div class="card">
                ${this.header 
                ? html`<div class="card-header ${this.variant}">${this.header}</div>` 
                : null}
                <div class="card-body">
                    <slot></slot>
                </div>
            </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-widget': TWidget;
  }
}